import { render, staticRenderFns } from "./SettingKouliang.vue?vue&type=template&id=ece0a9dc&scoped=true&"
import script from "./SettingKouliang.vue?vue&type=script&lang=js&"
export * from "./SettingKouliang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece0a9dc",
  null
  
)

export default component.exports